import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast, Toaster } from "sonner";
import { Cpu, CircleNotch } from "@phosphor-icons/react";

function formatErr(d) {
  if (!d) return "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map(e => e?.msg || JSON.stringify(e)).join(" ");
  return String(d);
}

export default function Login() {
  const nav = useNavigate();
  const loc = useLocation();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await login(email, password);
      toast.success(`Welcome back, ${user.name || user.email}`);
      const from = loc.state?.from || "/dashboard";
      nav(from);
    } catch (err) {
      toast.error(formatErr(err?.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0B1120] flex items-center justify-center px-4">
      <Toaster richColors position="top-right" theme="dark" />
      <div className="w-full max-w-md">
        <div className="flex items-center gap-3 mb-8 justify-center">
          <div className="w-10 h-10 border border-cyan-500 flex items-center justify-center">
            <Cpu size={22} weight="bold" className="text-cyan-400" />
          </div>
          <div>
            <div className="font-head font-black text-lg tracking-widest text-slate-100">CONEXUS TRADEBOT PRO</div>
            <div className="label-uppercase">Agentic OKX Trading</div>
          </div>
        </div>

        <form onSubmit={submit} className="bg-[#111827] border border-slate-700 p-6 space-y-4">
          <h1 className="font-head text-xl tracking-wider text-slate-100">SIGN IN</h1>
          <div className="space-y-2">
            <label className="label-uppercase">Email</label>
            <Input value={email} onChange={e => setEmail(e.target.value)} type="email" required
              data-testid="input-email"
              className="bg-[#0F172A] border-slate-700 h-10 font-mono text-sm" />
          </div>
          <div className="space-y-2">
            <label className="label-uppercase">Password</label>
            <Input value={password} onChange={e => setPassword(e.target.value)} type="password" required
              data-testid="input-password"
              className="bg-[#0F172A] border-slate-700 h-10 font-mono text-sm" />
          </div>
          <Button type="submit" disabled={loading}
            data-testid="btn-login"
            className="w-full bg-cyan-600 hover:bg-cyan-700 h-10 font-head tracking-wider">
            {loading ? <CircleNotch className="animate-spin mr-2" /> : null}
            SIGN IN
          </Button>
          <div className="text-xs text-slate-500 pt-2 border-t border-slate-800">
            Single-user platform. Contact your admin to reset credentials.
          </div>
        </form>
      </div>
    </div>
  );
}
